<template>
  <div class="app-content-wrapper">
    <div class="brand-settings-wrapper">
      <div class="settings-wrapper">
        <!-- <validation-component ref="validationForm"
                              size="small"
                              :validation-condition="validationCondition">
        </validation-component> -->
        <div v-if="brandinfo">
          <div class="label" style="margin-top: 0;">{{ $t('message.checkout.brandName') }}</div>
          <div class="content-text">{{ brandinfo.brand }}</div>
          <div class="label">{{ $t('message.checkout.logo') }}</div>
          <div class="content">
            <el-image v-if="brandinfo.logoImage" :fit="'cover'" class="img" :src="brandinfo.logoImage" :preview-src-list="[brandinfo.logoImage]" />
            <div v-else class="img"></div>
          </div>
          <div class="tip">{{ $t('message.checkout.brandLogoTip') }}</div>
          <div class="label">{{ $t('message.checkout.mainColor') }}</div>
          <div class="content">
            <div class="color-wrapper" :style="{'border-color': brandinfo.color ? brandinfo.color : ''}">
              <div class="color-box" :style="{'background-color': brandinfo.color ? brandinfo.color : ''}"></div>
              <div class="text-box"><span>#</span>{{ brandinfo.color ? brandinfo.color.replace('#', '') : '00A2DD' }}</div>
            </div>
          </div>
          <div class="tip">{{ $t('message.checkout.colorSelectTip') }}</div>
          <div class="label">{{ $t('message.checkout.customOptions') }}</div>
          <div class="content h-content">
            <div class="sub-label">{{ $t('message.checkout.isDisplayOrderNo') }}</div>
            <el-switch disabled v-model="viewTxnId"></el-switch>
          </div>
          <div class="content h-content">
            <div class="sub-label">{{ $t('message.checkout.viewCancelBtn') }}</div>
            <el-switch disabled v-model="brandinfo.viewCancelBtn"></el-switch>
          </div>
          <div class="content h-content">
            <div class="sub-label">{{ $t('message.checkout.viewCountryBtn') }}</div>
            <el-switch disabled v-model="viewCountryBtn"></el-switch>
          </div>
          <div class="label">{{ $t('message.checkout.useWebsite') }}
            <el-popover trigger="hover" class="i-popover" placement="right">
              <div v-html="$t('message.checkout.useWebsiteTip')"></div>
              <span class="iconfont icon-tishi003" slot="reference"></span>
            </el-popover>
          </div>
          <div class="content">
            <div class="app-list">
              <div class="app-item" v-for="(item, idx) in appWebisteList" :key="idx">
                {{ item.appName }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="demo-wrapper">
        <div style="display: flex;justify-content: flex-end;">
          <div class="tabs">
            <div class="tab phone" :class="{'active': demoDevice === 'phone'}" @click="demoDevice = 'phone'">
              <template v-if="demoDevice === 'phone'">
                <img src="../../../../assets/images/phone.png" />
              </template>
              <template v-else>
                <img src="../../../../assets/images/phone-default.png" />
              </template>
            </div>
            <div class="tab" :class="{'active': demoDevice === 'pc'}" @click="demoDevice = 'pc'">
              <template v-if="demoDevice === 'pc'">
                <img src="../../../../assets/images/pc.png" />
              </template>
              <template v-else>
                <img src="../../../../assets/images/pc-default.png" />
              </template>
            </div>
          </div>
        </div>
        <div class="demo-box">
          <template v-if="demoDevice === 'pc'">
            <div class="pc-demo">
              <img src="../../../../assets/images/checkout-pc.png" />
              <img v-if="logo" class="logo" :src="logo" />
              <span v-else-if="brandinfo.brand" class="brand">{{subCharByLength(brandinfo.brand, 30)}}</span>
              <div v-if="viewCountryBtn" class="country-info">
                <span>{{$t('message.checkout.selectCountry')}}</span>
                <i class="el-icon-arrow-down"></i>
              </div>
              <div v-if="viewTxnId" class="order-info">
                <div class="order-title">{{$t('message.checkout.orderNo')}}</div>
                <div class="order-no">xxxxxxxxxxxxxxxx</div>
              </div>
              <div class="button" :style="{'color': btnBackground}" :class="{ origin: !btnBackground, setting: btnBackground}">
                <div class="text">{{$t('message.checkout.pay')}} USD 100.00</div>
                <p v-if="viewCancelBtn" class="cancel" :style="{'color': btnBackground || '#00A2DD'}">{{$t('message.checkout.cancelReturn')}}</p>
              </div>
            </div>
          </template>
          <template v-else-if="demoDevice === 'phone'">
            <div class="phone-demo">
              <img src="../../../../assets/images/checkout-phone.png" />
              <img v-if="brandinfo.logo" class="logo" :src="logo" />
              <span v-else-if="brandinfo.brand" class="brand">{{subCharByLength(brandinfo.brand, 30)}}</span>
              <div v-if="viewCountryBtn" class="country-info">
                <span>{{$t('message.checkout.selectCountry')}}</span>
                <i class="el-icon-arrow-down"></i>
              </div>
              <div v-if="viewTxnId" class="order-info">
                <div class="order-title">{{$t('message.checkout.orderNo')}}</div>
                <div class="order-no">xxxxxxxxxxxxxxxx</div>
              </div>
              <div class="btn-box">
                <div class="button" :style="{'color': btnBackground}" :class="{ origin: !btnBackground, setting: btnBackground}">
                  <div class="text">{{$t('message.checkout.pay')}} USD 100.00</div>
                  <p v-if="viewCancelBtn" class="cancel" :style="{'color': btnBackground || '#00A2DD'}">{{$t('message.checkout.cancelReturn')}}</p>
                </div>
              </div>
            </div>
          </template>
      </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Loading } from 'element-ui';

import { subCharByLength } from '@/utils/tools/utils';
import ApplicationService from '@/views/application/api/application-list.service';

import { getBrandInfo } from '../../api/brand';

export default {
  data() {
    return {
      id: this.$route.query.id,
      demoDevice: 'pc',
      logo: require('../../../../assets/images/logo-default.png'),
      btnBackground: '',
      appWebisteList: [],
      brandinfo: null,
      viewCancelBtn: false,
      viewTxnId: true,
      viewCountryBtn: true,
    };
  },
  async created() {
    const loading = Loading.service();
    try {
      // 初始化应用下拉列表
      const res = await ApplicationService.getApplicationList({ size: -1 });
      res.content.unshift({ appName: this.$t('message.checkout.allWebsite'), id: 'ALL' });
      if (this.id) {
        this.brandinfo = await getBrandInfo({ id: this.id });
        if (this.brandinfo.appIds && this.brandinfo.appIds.length) {
          res.content.forEach((item) => {
            if (this.brandinfo.appIds.includes(item.id)) {
              this.appWebisteList.push(item);
            }
          });
        }
        this.logo = this.brandinfo.logoImage;
        this.btnBackground = this.brandinfo.color;
        this.viewCancelBtn = this.brandinfo.viewCancelBtn;
        this.viewTxnId = `${this.brandinfo.viewTxnId}` !== 'false';
        this.viewCountryBtn = `${this.brandinfo.viewCountryBtn}` !== 'false';
      }
    } catch (error) {
      console.log('Init View Brand Error', error);
    }
    loading.close();
  },
  methods: {
    subCharByLength,
    getDisplayOrderNoText() {
      if (`${this.brandinfo.viewTxnId}` === 'false') { // 兼容历史数据
        return this.$t('message.status.no');
      }
      return this.$t('message.status.yes');
    },
  },
};
</script>
<style lang="scss" scoped>
@import '~@/styles/variables.scss';

.app-content-wrapper {
  border: 1px solid $color-default;
  .brand-settings-wrapper {
    display: flex;
    .settings-wrapper {
      border-right: 1px solid $color-default;
      width: 320px;
      padding: 20px;
      .label {
        font-size: 14px;
        font-weight: 800;
        color: $color-text-primary;
        line-height: 32px;
        margin-top: 20px;
        display: flex;
        align-items: center;
        .icon-tishi003 {
          color: #43618A;
          opacity: 0.7;
          margin-left: 0.2rem;
        }
      }
      .content-text {
        font-size: 14px;
        font-weight: 400;
        color: $color-text-primary;
        line-height: 32px;
      }
      .content {
        &.h-content {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: 10px;
          .label {
            margin-top: 0;
          }

          .sub-label {
            font-size: 14px;
          }
        }
        .img {
          height: 60px;
          width: auto;
          max-width: 320px;
          ::v-deep img {
            width: auto;
            max-width: 320px;
          }
        }
        .color-wrapper {
          height: 32px;
          width: 183px;
          border: 1px solid $color-primary;
          display: flex;
          box-sizing: border-box;
          .color-box {
            width: 60px;
            background-color: $color-primary;
            box-sizing: border-box;
          }
          .text-box {
            color: $color-text-primary;
            font-size: 14px;
            font-weight: 600;
            text-align: center;
            line-height: 32px;
            width: 123px;
            box-sizing: border-box;
            span {
              color: rgba(38,67,115,0.6);
              margin-right: 5px;
            }
          }
        }
      }
      .tip {
        font-weight: 400;
        font-size: 13px;
        color: rgba(38,67,115,0.6);
        line-height: 20px;
        margin-top: 5px
      }
      .app-list {
        max-height: 300px;
        overflow-y: auto;
        margin-top: 10px;
        .app-item {
          font-weight: 400;
          font-size: 14px;
          color: $color-text-primary;
          line-height: 28px;
        }
      }
    }
    .demo-wrapper {
      width: 100%;
      background-color: $color-default;
      padding-bottom: 150px;
      .tabs {
        display: flex;
        height: 36px;
        box-shadow: 0px 4px 10px 0px rgba(141,141,141,0.3);
        border-radius: 4px 4px 4px 4px;
        background: #FFFFFF;
        width: 100px;
        margin-top: 54px;
        margin-right: 50px;
        .tab {
          width: 50px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          img {
            width: 22px;
          }
          &.phone {
            border-right: 1px solid #EBEBEB;
          }
        }
      }
      .demo-box {
        display: flex;
        justify-content: center;
        .pc-demo {
          position: relative;
          text-align: center;
          margin-top: 100px;
          display: inline-block;
          .logo {
            position: absolute;
            left: 47px;
            top: 8px;
            height: 25px;
            width: auto;
          }
          .country-info {
            position: absolute;
            top: 60px;
            left: 47px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 178px;
            height: 22px;
            background-color: #F3F3F3;
            border-radius: 2px;
            font-weight: 500;
            font-size: 8px;
            color: #C1C1C1;
            line-height: 23px;
            padding-left: 4px;
            padding-right: 10px;
            box-sizing: border-box;
            .el-icon-arrow-down {
              font-size: 8px !important;
            }
          }
          .order-info {
            position: absolute;
            top: 127px;
            right: 44px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 281px;
            font-weight: 500;
            font-size: 8px;
            color: #C1C1C1;
            .order-title {
              width: 69px;
              height: 18px;
              background: #F3F3F3;
              border-radius: 2px;
              display: flex;
              align-items: center;
              padding-left: 5px;
              box-sizing: border-box;
            }
            .order-no {
              width: 130px;
              height: 18px;
              background: #F3F3F3;
              border-radius: 2px;
              display: flex;
              align-items: center;
              justify-content: flex-end;
              padding-right: 5px;
              box-sizing: border-box;
            }
          }
          .brand {
            position: absolute;
            left: 47px;
            top: 14px;
            width: auto;
            font-size: 10px;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
          .button {
            position: absolute;
            left: 47px;
            bottom: 38px;
            height: 26px;
            width: 266px;
            border-radius: 2px 2px 2px 2px;
            font-weight: 600;
            font-size: 12px;
            line-height: 26px;
            background-color: currentColor;
            &.origin {
              background-color: #00A2DD;
              color: #FFF;
            }
            &.setting {
              .text {
                filter: grayscale(1) contrast(999) invert(1);
              }
            }
            .cancel {
              font-size: 10px;
            }
          }
        }
        .phone-demo {
          position: relative;
          text-align: center;
          margin-top: 50px;
          display: inline-block;
          .logo {
            position: absolute;
            left:18px;
            top: 70px;
            max-height: 25px;
            max-width: 160px;
          }
          .country-info {
            position: absolute;
            top: 122px;
            left: 18px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 212px;
            height: 15px;
            background-color: #F3F3F3;
            border-radius: 2px;
            font-weight: 500;
            font-size: 8px;
            color: #C1C1C1;
            line-height: 23px;
            padding-left: 4px;
            padding-right: 10px;
            box-sizing: border-box;
            .el-icon-arrow-down {
              font-size: 8px !important;
            }
          }
          .order-info {
            position: absolute;
            top: 321px;
            right: 18px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 214px;
            font-weight: 500;
            font-size: 8px;
            color: #C1C1C1;
            .order-title {
              width: 58px;
              height: 13px;
              background: #F3F3F3;
              border-radius: 2px;
              display: flex;
              align-items: center;
              padding-left: 5px;
              box-sizing: border-box;
            }
            .order-no {
              width: 127px;
              height: 13px;
              background: #F3F3F3;
              border-radius: 2px;
              display: flex;
              align-items: center;
              justify-content: flex-end;
              padding-right: 5px;
              box-sizing: border-box;
            }
          }
          .brand {
            position: absolute;
            left:18px;
            top: 75px;
            font-size: 10px;
            max-width: 170px;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
          .btn-box {
            padding: 0 17px;
            position: absolute;
            width: 100%;
            box-sizing: border-box;
            bottom: 80px;
            left: 0;
            .button {
              width: 100%;
              height: 26px;
              border-radius: 2px 2px 2px 2px;
              font-weight: 600;
              font-size: 12px;
              line-height: 26px;
              background-color: currentColor;
              &.origin {
                background-color: #00A2DD;
                color: #FFF;
              }
              &.setting {
                .text {
                  filter: grayscale(1) contrast(999) invert(1);
                }
              }
              .cancel {
                font-size: 10px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
